//#region ImportSection
import React, { useEffect, useState } from "react";
import { Row } from "reactstrap";
import { DragDropContext } from "react-beautiful-dnd";

import ApiHabibProgress from "../config/habibprogress/ApiHabibProgress";
import AddProgressComment from "./AddProgressComment";
import UpdateMemberNisab from "./UpdateMemberNisab";
import SelectAssociatedMember from "./ContactFormAhbab/SelectAssociatedMember";
import MoveMemberModal from "../member/MoveMemberModal";
import ViewMemberComments from "./ViewMemberComments";
import { LoadingSpinner } from "../../constants/const";
import ProgressColumn from "./ProgressColumn";
//endregion ImportSection
const HabibProgressBoard = ({ boardData, refreshBoard, searchAhbabModel }) => {
  //#region StateSection
  const [loading, setLoading] = useState(false);

  const [columns, setColumns] = useState([]);
  const [selectedTask, setSelectedTask] = React.useState(null);
  const [showCommentModal, setShowCommentModal] = React.useState(false);
  const [showViewCommentModal, setShowViewCommentModal] = React.useState(false);

  const [showAddMemberNisabModel, setshowAddMemberNisabModel] = useState(false);
  const [showAssociatedMemberModal, setShowAssociatedMemberModal] =
    useState(false);
  const [moveHabibModal, setMoveHabibModal] = useState(false);
  const [refreshList, setRefreshList] = useState(false);
  const [check, setCheck] = useState();
  //#endregion StateSection
  //#region EffectSection
  useEffect(() => {
    setColumns(boardData);
  }, [boardData]);

  //#endregion EffectSection
  //#region FunctionSection
  if (refreshList) {
    if (typeof refreshBoard === "function") {
      refreshBoard();
    }
    setRefreshList(false);
  }

  const handleOpenCommentModal = (task) => {
    setSelectedTask(task);
    setShowCommentModal(true);
  };
  const handleOpenViewCommentModal = (task) => {
    setSelectedTask(task);
    setShowViewCommentModal(true);
  };
  const handleOpenMoveMemberModal = (task, check) => {
    setCheck(check);
    setSelectedTask(task);
    setMoveHabibModal(true);
  };
  const handleOpenAssociateMemberModal = (task) => {
    setSelectedTask(task);
    setShowAssociatedMemberModal(true);
  };

  const handleCloseCommentModal = () => {
    setSelectedTask(null);
    setShowCommentModal(false);
    setshowAddMemberNisabModel(false);
    setShowViewCommentModal(false);
  };
  const handleCloseNisabModal = () => {
    setshowAddMemberNisabModel(false);
  };
  const handleOpenaddNisabModel = (task) => {
    setSelectedTask(task);
    setshowAddMemberNisabModel(true);
  };
  const onchangestatushandler = async (prog, task) => {
    try {
      if (!prog || !prog.task || !prog.prog) {
        return;
      }

      // 1. Save old column id for rollback
      const oldProgressId = prog.task.progressId;
      const newProgressId = prog.prog.id;
      const habibId = prog.task.habibId;

      // 2. Immediately update UI (optimistic update)
      setColumns((prevColumns) => {
        try {
          if (!Array.isArray(prevColumns)) return prevColumns;

          const updated = [...prevColumns];

          // 1. Find old column
          const oldCol = updated.find((col) => col.id === oldProgressId);
          if (!oldCol) return prevColumns;

          // 2. Get the habib
          const habib = oldCol.ahbab?.find((m) => m.habibId === habibId);
          if (!habib) return prevColumns;

          // 3. Remove from old column
          oldCol.ahbab = oldCol.ahbab.filter((m) => m.habibId !== habibId);

          // 4. Find new column and add habib with updated progressId
          const newCol = updated.find((col) => col.id === newProgressId);
          if (newCol) {
            newCol.ahbab = [
              ...(newCol.ahbab || []),
              { ...habib, progressId: newProgressId },
            ];
          }

          return updated;
        } catch (innerErr) {
          console.error("Error while updating columns:", innerErr);
          return prevColumns;
        }
      });

      try {
        await ApiHabibProgress().AddHabibProgress({
          habibId: habibId,
          progressId: newProgressId,
        });
      } catch (apiErr) {
        console.error("Failed to update status:", apiErr);

        // Optional rollback if API fails
        setColumns((prevColumns) => {
          try {
            let updated = [...prevColumns];

            // Remove from new column
            updated = updated.map((col) => {
              if (col.progressId === prog.id) {
                return {
                  ...col,
                  tasks: (col.tasks || []).filter((t) => t.id !== task?.id),
                };
              }
              return col;
            });

            // Add back to old column
            updated = updated.map((col) => {
              if (col.progressId === oldProgressId) {
                return {
                  ...col,
                  tasks: [
                    ...(col.tasks || []),
                    { ...task, progressId: oldProgressId },
                  ],
                };
              }
              return col;
            });

            return updated;
          } catch (rollbackErr) {
            console.error("Rollback failed:", rollbackErr);
            return prevColumns;
          }
        });
      }

      if (typeof refreshBoard === "function") {
        refreshBoard();
      }
    } catch (err) {
      console.error("Unexpected error in onchangestatushandler:", err);
    }
  };

  const moveVersionRef = React.useRef({});

  const handleDragEnd = async (result) => {
    const { destination, source } = result;
    if (!destination) return;

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    )
      return;
    setLoading(false);
    const sourceColIndex = columns.findIndex(
      (col) => col.id.toString() === source.droppableId
    );
    const destColIndex = columns.findIndex(
      (col) => col.id.toString() === destination.droppableId
    );

    const sourceColumn = columns[sourceColIndex];
    const destColumn = columns[destColIndex];
    const draggedTask = sourceColumn.ahbab[source.index];

    // Local UI update
    const updatedSourceMembers = [...sourceColumn.ahbab];
    updatedSourceMembers.splice(source.index, 1);

    const updatedDestMembers = [...destColumn.ahbab];
    updatedDestMembers.splice(destination.index, 0, draggedTask);

    const updatedColumns = [...columns];
    updatedColumns[sourceColIndex] = {
      ...sourceColumn,
      ahbab: updatedSourceMembers,
    };
    updatedColumns[destColIndex] = {
      ...destColumn,
      ahbab: updatedDestMembers,
    };

    setColumns(updatedColumns);

    // Increment version BEFORE the API call
    moveVersionRef.current[draggedTask.id] =
      (moveVersionRef.current[draggedTask.id] || 0) + 1;

    //const requestVersion = moveVersionRef.current[draggedTask.id];

    try {
      await ApiHabibProgress().AddHabibProgress({
        id: draggedTask.id,
        habibId: draggedTask.habibId,
        progressId: parseInt(destination.droppableId),
        newPosition: destination.index,
      });

      setLoading(false);
    } catch (err) {}
  };

  //#endregion FunctionSection

  const topScrollRef = React.useRef(null);
  const bottomScrollRef = React.useRef(null);

  useEffect(() => {
    const top = topScrollRef.current;
    const bottom = bottomScrollRef.current;
    if (!top || !bottom) return;

    const syncTop = () => (bottom.scrollLeft = top.scrollLeft);
    const syncBottom = () => (top.scrollLeft = bottom.scrollLeft);

    top.addEventListener("scroll", syncTop);
    bottom.addEventListener("scroll", syncBottom);

    return () => {
      top.removeEventListener("scroll", syncTop);
      bottom.removeEventListener("scroll", syncBottom);
    };
  }, []);

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <div
        style={{
          padding: "0rem",
          overflowX: "auto",
        }}
      >
        {!loading ? (
          <Row className="w-100">
            {showCommentModal && (
              <AddProgressComment
                task={selectedTask}
                onClose={handleCloseCommentModal}
                refreshBoard={refreshBoard}
              />
            )}
            {showViewCommentModal && (
              <ViewMemberComments
                task={selectedTask}
                onClose={handleCloseCommentModal}
                refreshBoard={refreshBoard}
              />
            )}
            {showAddMemberNisabModel && (
              <UpdateMemberNisab
                task={selectedTask}
                onClose={handleCloseNisabModal}
                refreshBoard={refreshBoard}
              />
            )}
            {showAssociatedMemberModal && (
              <SelectAssociatedMember
                memberHabibId={selectedTask.habibId}
                habibUnitId={selectedTask.unitId}
                setShowAssociatedMemberModal={setShowAssociatedMemberModal}
                setRefreshList={setRefreshList}
                refreshList={refreshList}
              />
            )}
            {moveHabibModal && (
              <MoveMemberModal
                memberId={selectedTask.habibId}
                unitId={selectedTask.unitId}
                check={check}
                setRefresh={setRefreshList}
                refresh={refreshList}
                setMoveMemberModal={setMoveHabibModal}
                calledAs={"habib"}
              />
            )}
            {/* Top Scrollbar */}
            <div
              style={{
                height: "80vh", // full screen height
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Static Top Header */}

              {/* Scrollable Area */}
              <div
                style={{
                  flex: 1,
                  overflowX: "auto",
                  overflowY: "auto",
                }}
              >
                {/* Titles Row */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(5, minmax(250px, 1fr))",
                    gap: "1rem",
                    paddingRight: "1rem",

                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  {columns.map((column, index) => (
                    <div
                      key={index}
                      style={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      <div
                        className="ur"
                        style={{
                          backgroundColor: "#1ab394",
                          color: "white",
                          padding: "14px",
                          textAlign: "center",
                          fontSize: "1.2em",
                          borderTopLeftRadius: "12px",
                          borderTopRightRadius: "12px",
                          margin: 0,
                          fontWeight: 600,
                        }}
                      >
                        {column.progressName}
                      </div>
                    </div>
                  ))}
                </div>

                {/* Columns Row */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(5, minmax(250px, 1fr))",
                    gap: "1rem",
                    padding: "1rem",
                  }}
                >
                  {columns.map((column, index) => (
                    <ProgressColumn
                      key={column.id}
                      columnIndex={index}
                      title={column.progressName}
                      task={column.ahbab}
                      id={column.id.toString()}
                      onComment={handleOpenCommentModal}
                      viewComments={handleOpenViewCommentModal}
                      onUpdateNisabClick={handleOpenaddNisabModel}
                      onUpdateAssociateMemberClick={
                        handleOpenAssociateMemberModal
                      }
                      onMoveMemberClick={handleOpenMoveMemberModal}
                      progress={columns}
                      onchangestatus={onchangestatushandler}
                    />
                  ))}
                </div>
              </div>
            </div>
          </Row>
        ) : (
          LoadingSpinner()
        )}
      </div>
    </DragDropContext>
  );
};

export default HabibProgressBoard;
